export const DEFAULT_RANGE_PRESET_DAYS = [7, 31, 60, 90];
export const DEFAULT_DUE_DATE_PRESET_DAYS = [7, 31, 60, 90];

export const getDateKey = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const addDays = (date, days) => {
  const next = new Date(date);
  next.setDate(next.getDate() + days);
  return next;
};

export const getRangeFromDays = (days, direction = "past") => {
  const normalizedDays = Number(days);
  const today = new Date();
  const isFuture = direction === "future";
  const start = isFuture ? today : addDays(today, -(normalizedDays - 1));
  const end = isFuture ? addDays(today, normalizedDays - 1) : today;
  return {
    startDate: getDateKey(start),
    endDate: getDateKey(end),
  };
};

export const getDueDateFromDays = (days) => {
  const normalizedDays = Number(days);
  return getDateKey(addDays(new Date(), normalizedDays));
};

export const resolveRangePresetValue = (
  startDate,
  endDate,
  presetDays = DEFAULT_RANGE_PRESET_DAYS,
  direction = "past"
) => {
  if (!startDate || !endDate) return "";
  const today = new Date();
  const startKey = getDateKey(today);
  const endKey = getDateKey(today);
  if (direction === "future") {
    if (startDate !== startKey) return "custom";
  } else if (endDate !== endKey) {
    return "custom";
  }
  for (const days of presetDays) {
    const range = getRangeFromDays(days, direction);
    if (startDate === range.startDate && endDate === range.endDate) {
      return String(days);
    }
  }
  return "custom";
};

export const resolveDueDatePresetValue = (
  dateValue,
  presetDays = DEFAULT_DUE_DATE_PRESET_DAYS
) => {
  if (!dateValue) return "custom";
  const today = new Date();
  for (const days of presetDays) {
    const expected = getDateKey(addDays(today, Number(days)));
    if (dateValue === expected) return String(days);
  }
  return "custom";
};
